import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {StyledContainer} from './styles';

const {line1} =
	translations['pt-br'].privateFlow.myHospitalization.generalOrientations.cards.visitingHours;

export const VisitingHour = () => (
	<StyledContainer>
		<Typography variant="body1">{line1}</Typography>
	</StyledContainer>
);
